import { render, staticRenderFns } from "./StopDetails.vue?vue&type=template&id=91b29f24&scoped=true&"
import script from "./StopDetails.vue?vue&type=script&lang=js&"
export * from "./StopDetails.vue?vue&type=script&lang=js&"
import style0 from "./StopDetails.vue?vue&type=style&index=0&id=91b29f24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b29f24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91b29f24')) {
      api.createRecord('91b29f24', component.options)
    } else {
      api.reload('91b29f24', component.options)
    }
    module.hot.accept("./StopDetails.vue?vue&type=template&id=91b29f24&scoped=true&", function () {
      api.rerender('91b29f24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Stops/StopDetails.vue"
export default component.exports